export default __webpack_public_path__ + "static/media/advantages__item-icon-1.7421cb59.svg";